var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreedotsFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 2.00005C-0.000244141 2.85564 0.69978 3.55566 1.55537 3.55566C2.41095 3.55566 3.11098 2.85564 3.11098 2.00005C3.11098 1.14447 2.41095 0.444444 1.55537 0.444444C0.69978 0.444444 -0.000244141 1.14447 -0.000244141 2.00005ZM10.889 2.00005C10.889 2.85564 11.589 3.55566 12.4446 3.55566C13.3002 3.55566 14.0002 2.85564 14.0002 2.00005C14.0002 1.14447 13.3002 0.444444 12.4446 0.444444C11.589 0.444444 10.889 1.14447 10.889 2.00005ZM5.44439 2.00005C5.44439 2.85564 6.14441 3.55566 7 3.55566C7.85559 3.55566 8.55561 2.85564 8.55561 2.00005C8.55561 1.14447 7.85559 0.444444 7 0.444444C6.14441 0.444444 5.44439 1.14447 5.44439 2.00005Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsFunnel);
export default __webpack_public_path__ + "static/media/threedotsFunnel.f14ba2af125ab3bf506db185376f506b.svg";
export { ForwardRef as ReactComponent };